<!--
    描述：修改密码
    时间：2021-02-04
    Created by yefan
-->
<template>
    <div class="h100">
        <el-form :model="passwordForm"
                 :rules="passwordRules"
                 ref="passwordForm"
                 label-width="90px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="旧密码" prop="oldPassword">
                        <el-input v-model="passwordForm.oldPassword" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input v-model="passwordForm.newPassword" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="确认密码" prop="trueNewPassword">
                        <el-input @blur="checkPass" v-model="passwordForm.trueNewPassword"
                                  autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {mapActions, mapState} from 'vuex'
    import {updatePassword} from '@/api/modules/user.js'
    export default {
        data() {
            return {
                roleTreeData: [],
                passwordForm: {
                    newPassword: '',
                    trueNewPassword: null,
                    oldPassword: '',
                },
                passwordRules: {
                    oldPassword: [
                        {
                            required: true,
                            message: '旧密码不能为空',
                            trigger: 'blur'
                        }
                    ],
                    newPassword: [
                        {
                            required: true,
                            message: '新密码不能为空',
                            trigger: 'blur'
                        }],
                    trueNewPassword: [
                        {
                            required: true,
                            message: '请确认新密码',
                            trigger: 'blur'
                        }],
                },
            }
        },

        methods: {
            // 确认修改
            sumbitPass() {
                this.$refs.passwordForm.validate(valid => {
                    if (valid) {
                        updatePassword({
                            id: this.userInfo.id,
                            oldPassword: this.passwordForm.oldPassword,
                            newPassword: this.passwordForm.newPassword,
                            trueNewPassword: this.passwordForm.trueNewPassword
                        }).then(d => {
                            if (d.code === 0) {
                                this.$message.success('保存成功，请重新登录')
                                setTimeout(() => {
                                    this.$router.push({path: '/login'})
                                }, 1000)
                            } else {
                                this.$message.error(d.msg)
                            }
                        })
                    } else {
                        this.$message.error('请校验表单！')
                    }
                })
            },

            // 比对两次新密码是否一致
            checkPass() {
                if (
                    this.passwordForm.trueNewPassword != this.passwordForm.newPassword &&
                    this.passwordForm.newPassword != '' &&
                    this.passwordForm.trueNewPassword != ''
                ) {
                    this.$message.error('两次密码不一致，请重新输入！')
                    this.passwordForm.trueNewPassword = ''
                }
            },
        },

        computed: {
            ...mapState('user', {
                userInfo: state => state.userInfo
            })
        }
    }
</script>

<style lang="less"></style>
